import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scoped.css';
import { Modal } from '@mantine/core';
import Maps from '../../elements/Maps/Maps';
import Button from '../../elements/Button';

function Coordinates({
  className,
  input,
  inputProps,
  meta: { touched, error },
  // hideLabel = false
}) {
  const initialCoordinate = {
    lat: parseFloat(input?.value?.split(',')[0]),
    lng: parseFloat(input?.value?.split(',')[1]),
  };
  const isError = touched && error ? 'isError' : '';
  const classes = ['root', className, isError].filter(Boolean).join(' ');
  const [isOpen, setIsOpen] = useState(false);
  const [coordinate, setCoordinate] = useState({ lat: 0, lng: 0 });

  const computed = `${coordinate.lat}, ${coordinate.lng}`;

  const handleChangeCoordinate = (event) => {
    setCoordinate({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    });
  };
  const handleSaveCoordinate = () => {
    input.onChange(computed);
    setIsOpen(false);
  };
  const handleCancel = () => {
    setCoordinate(initialCoordinate);
    setIsOpen(false);
  };
  const handleChangeCoordinateBySearch = (value) => {
    const place = value.getPlace();
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    setCoordinate({ lat, lng });
  };

  useEffect(() => {
    if (input.value) {
      setCoordinate(initialCoordinate);
    }
  }, [input.value]);

  return (
    <>
      <div className={styles.containerField}>
        {inputProps.label && <label>{inputProps.label}</label>}
        <div className={classes} onClick={() => setIsOpen(true)} role="button">
          <input
            {...inputProps}
            {...input}
            className={styles['input-field']}
            disabled
            type="text"
            value={computed}
          />
        </div>
        {touched && error && <span className={styles.error}>{error}</span>}
      </div>
      <Modal
        centered
        lastUpdate={new Date()}
        onClose={() => setIsOpen(false)}
        opened={isOpen}
        size={'lg'}
        title="Cari Lokasi Alamat"
      >
        <div className={styles.modalContent}>
          <Maps
            autoComplete
            centerPoint={coordinate}
            onClick={handleChangeCoordinate}
            onPlaceChanged={handleChangeCoordinateBySearch}
            options={{
              disableDefaultUI: true,
              draggableCursor: 'default',
              draggingCursor: 'pointer',
            }}
          />
        </div>
        <div className={styles.modalAction}>
          <div>
            <Button onClick={handleCancel}>Batal</Button>
            <Button onClick={handleSaveCoordinate} >
              Simpan
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}

Coordinates.propTypes = {
  className: PropTypes.string,
  hideLabel: PropTypes.bool,
  input: PropTypes.object,
  inputProps: PropTypes.object,
  meta: PropTypes.object,
};

export default Coordinates;
